import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';

type CapacityExceededConfirmationDialogProps = {
    mode: 'create' | 'edit';
    show: boolean;
    onEdit: () => void;
    onConfirm: () => void;
};

export const CapacityExceededConfirmationDialog = ({
    mode,
    show,
    onEdit,
    onConfirm,
}: CapacityExceededConfirmationDialogProps) => {
    const isEditMode = mode === 'edit';

    return (
        <ConfirmationDialog
            show={show}
            title={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.title' />
            }
            content={
                <FormattedMessage
                    id={
                        isEditMode
                            ? 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.edit-content'
                            : 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.content'
                    }
                />
            }
            cancelButtonText={
                <FormattedMessage id='intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.edit' />
            }
            confirmButtonText={
                <FormattedMessage
                    id={
                        isEditMode
                            ? 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.save-anyway'
                            : 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.confirmation.create-anyway'
                    }
                />
            }
            onClickCancel={onEdit}
            onClickConfirm={onConfirm}
        />
    );
};
